import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#141329',
        padding: '48px 0',
        '& > span': {
            fontSize: '48px',
            fontWeight: '800',
            color: '#fff',
            textAlign: 'center',
            marginBottom: '24px',
            [theme.breakpoints.down('md')]: {
                fontSize: '30px',
                lineHeight: '40px',
                padding: '0 24px',
            },
            [theme.breakpoints.up('md')]: {
                marginBottom: 36
            }
        },
        [theme.breakpoints.down('md')]: {
            padding: '34px 0 40px 0px',
        }
    },
    carouselContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    desktopLayout: {
        display: 'none',
        [theme.breakpoints.up('lg')]: {
            display: 'block',
            width: '100%',
            overflow: 'hidden',
        }
    },
    mobileLayout: {
        display: 'block',
        width: '100%',
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        }
    },
    carouselWrapper: {
        width: '100%',
        overflow: 'hidden',
        position: 'relative',
        [theme.breakpoints.up('lg')]: {
            display: 'flex',
            justifyContent: 'center',
        }
    },
    carouselTrack: {
        display: 'flex',
        transition: 'transform 0.5s ease-in-out',
        width: '100%',
        [theme.breakpoints.up('lg')]: {
            gap: '24px',
            justifyContent: 'flex-start',
            width: 'max-content',
            minWidth: 'max-content',
        }
    },
    carouselSlide: {
        minWidth: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0 24px',
    },
    ctnTestimony: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#18181B',
        minWidth: 630,
        padding: '32px 24px',
        borderRadius: 20,
        cursor: 'pointer',
        transition: 'transform 0.3s ease',
        '&:hover': {
            transform: 'scale(1.02)',
        },
        [theme.breakpoints.down('md')]: {
            minWidth: 'calc(100vw - 48px)',
            width: 'calc(100vw - 48px)',
            maxWidth: 'calc(100vw - 48px)',
            padding: 24,
        },
        [theme.breakpoints.up('lg')]: {
            minWidth: 630,
            width: 630,
            flexShrink: 0,
        }
    },
    ctnStar: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        '& > img': {
            width: 24,
            height: 24,
            '&:not(:last-child)': {
                marginRight: 6
            },
        },
        marginBottom: 16
    },
    ctnText: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        // marginTop: 24,
        '& > span': {
            fontSize: 18,
            fontWeight: 600,
            color: '#fff',
            textAlign: 'center',
            [theme.breakpoints.down('sm')]: {
                fontSize: 16,
            }
        }
    },
    ctnUser: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 34
    },
    ctnImage: {
        width: 24,
        height: 24,
        borderRadius: '50%',
        overflow: 'hidden',
        marginRight: 12,
        '& > img': {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
        },
        [theme.breakpoints.down('sm')]: {
            width: 20,
            height: 20,
        }
    },
    ctnName: {
        '& > span': {
            fontSize: 18,
            fontWeight: 600,
            color: '#fff',
            [theme.breakpoints.down('sm')]: {
                fontSize: 14,
            }
        }
    },
    dotNavigation: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '12px',
        marginTop: '32px',
    },
    dot: {
        width: '12px',
        height: '12px',
        minWidth: '12px',
        minHeight: '12px',
        borderRadius: '50%',
        border: 'none',
        padding: 0,
        WebkitAppearance: 'none',
        background: '#FFFFFF',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        '&:hover': {
            background: '#667eea',
            transform: 'scale(1.2)',
        }
    },
    activeDot: {
        background: '#403DE3',
        transform: 'scale(1.2)',
    }
}));

export default useStyles;